import { useContext } from "react";
import Layout from "../../../../../global/component/Genericos/Layout/Layout";
import Modal from "../../../../../global/component/Genericos/Modal/Modal";
import { GlobalContext } from "../../../../../global/context/Provider";
import { BodyContainerPASO, ContainerPaso, HeaderBar } from "./localStyle";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import LogoDim from "_+_Portal/assets/images/generico/LogoDim";

const LayoutPasos = ({
  volverTo,
  children,
  handleClick,
  title,
  subtitle,
  type,
}) => {
  const { modalState, configState } = useContext(GlobalContext);

  const { pasoDispatch } = useContext(AutocheckContext);

  const limpiar = () => {
    if (handleClick) {
      handleClick();
    } else {
      setPaso("Home")(pasoDispatch);
    }
  };

  return (
    <Layout origen={"NULL"}>
      {modalState.modal.show && <Modal></Modal>}
      <ContainerPaso>
        <HeaderBar circle={type === "no-circle" ? 0 : 1}>
          <div className="arrow" onClick={limpiar}>
            {"<"}
          </div>
          <h1 className="title rb16m">{title}</h1>
          <p className="rb14l">{subtitle ? subtitle : ""}</p>
          {/* <span className="rb12tl">{subtitle}</span> */}
        </HeaderBar>
        <BodyContainerPASO>
          {children}
          {configState.config.data &&
          configState.config.data.portal === "dim" ? (
            <div className="logo-dim">
              <LogoDim height={"550"} />
            </div>
          ) : (
            ""
          )}
        </BodyContainerPASO>
      </ContainerPaso>
    </Layout>
  );
};

export default LayoutPasos;
